module.exports = __webpack_public_path__ + "static/media/when-we-all-fall-asleep.5016ca82.jpg";